export default __webpack_public_path__ + "static/media/i4000.b99ffb5b.jpg";